var recaptcha_loaded = false;
$('.js-recaptcha-entrypoint').click(function () {
    if (!recaptcha_loaded) {
        recaptcha_loaded = true;
        var script = document.createElement("script");
        script.src = $('.js-script-recaptcha').attr('data-src');
        document.body.appendChild(script);
    }
});